// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Distributor Form Styles
 * Clean, responsive styles matching UserCreateModal layout
 */

/* Modal Overlay - Now using global styles from design-system.css */

/* Modal Container - Now using global styles from design-system.css */

/* Modal Header - Now using global styles from design-system.css */

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.close-btn:hover:not(:disabled) {
    background: #e9ecef;
    color: #333;
}

.close-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Modal Body - Now using global styles from design-system.css */

/* Form Sections - Now using global styles from design-system.css */

/* Form Rows - Now using global styles from design-system.css */

/* Form Groups - Now using global styles from design-system.css */

/* Checkbox Group */
.checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    font-size: 0.9rem;
    color: #333;
    -webkit-user-select: none;
            user-select: none;
}

.checkbox-label input[type="checkbox"] {
    display: none;
}

.checkmark {
    width: 20px;
    height: 20px;
    border: 2px solid #e9ecef;
    border-radius: 4px;
    background: white;
    position: relative;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.checkbox-label input[type="checkbox"]:checked+.checkmark {
    background: #0D3B66;
    border-color: #0D3B66;
}

.checkbox-label input[type="checkbox"]:checked+.checkmark::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: bold;
}

.checkbox-label input[type="checkbox"]:disabled+.checkmark {
    background: #f8f9fa;
    border-color: #dee2e6;
    cursor: not-allowed;
}

/* Error Messages */
.field-error {
    color: #dc3545;
    font-size: 0.8rem;
    margin-top: 4px;
}

/* Modal Footer - Now using global styles from design-system.css */

/* Buttons - Now using global styles from design-system.css */

/* Responsive Design */
@media (min-width: 768px) {
    .form-row {
        grid-template-columns: 1fr 1fr;
    }

    .form-row:first-child {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 767px) {
    .modal-overlay {
        padding: 10px;
    }

    .modal-container {
        max-height: 95vh;
    }

    .modal-header {
        padding: 16px 20px;
    }

    .modal-header h2 {
        font-size: 1.3rem;
    }

    .modal-body {
        padding: 20px;
    }

    .modal-footer {
        padding: 16px 20px;
        flex-direction: column;
    }

    .btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .modal-header {
        padding: 12px 16px;
    }

    .modal-body {
        padding: 16px;
    }

    .modal-footer {
        padding: 12px 16px;
    }

    .form-section {
        margin-bottom: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/distributors/DistributorForm.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mEAAmE;;AAEnE,qEAAqE;;AAErE,kEAAkE;;AAElE;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,gEAAgE;;AAEhE,mEAAmE;;AAEnE,+DAA+D;;AAE/D,iEAAiE;;AAEjE,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA,kEAAkE;;AAElE,6DAA6D;;AAE7D,sBAAsB;AACtB;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/**\n * Distributor Form Styles\n * Clean, responsive styles matching UserCreateModal layout\n */\n\n/* Modal Overlay - Now using global styles from design-system.css */\n\n/* Modal Container - Now using global styles from design-system.css */\n\n/* Modal Header - Now using global styles from design-system.css */\n\n.close-btn {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #666;\n    padding: 4px;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n}\n\n.close-btn:hover:not(:disabled) {\n    background: #e9ecef;\n    color: #333;\n}\n\n.close-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* Modal Body - Now using global styles from design-system.css */\n\n/* Form Sections - Now using global styles from design-system.css */\n\n/* Form Rows - Now using global styles from design-system.css */\n\n/* Form Groups - Now using global styles from design-system.css */\n\n/* Checkbox Group */\n.checkbox-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    color: #333;\n    user-select: none;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n    display: none;\n}\n\n.checkmark {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #e9ecef;\n    border-radius: 4px;\n    background: white;\n    position: relative;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark {\n    background: #0D3B66;\n    border-color: #0D3B66;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked+.checkmark::after {\n    content: '✓';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: white;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.checkbox-label input[type=\"checkbox\"]:disabled+.checkmark {\n    background: #f8f9fa;\n    border-color: #dee2e6;\n    cursor: not-allowed;\n}\n\n/* Error Messages */\n.field-error {\n    color: #dc3545;\n    font-size: 0.8rem;\n    margin-top: 4px;\n}\n\n/* Modal Footer - Now using global styles from design-system.css */\n\n/* Buttons - Now using global styles from design-system.css */\n\n/* Responsive Design */\n@media (min-width: 768px) {\n    .form-row {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .form-row:first-child {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 767px) {\n    .modal-overlay {\n        padding: 10px;\n    }\n\n    .modal-container {\n        max-height: 95vh;\n    }\n\n    .modal-header {\n        padding: 16px 20px;\n    }\n\n    .modal-header h2 {\n        font-size: 1.3rem;\n    }\n\n    .modal-body {\n        padding: 20px;\n    }\n\n    .modal-footer {\n        padding: 16px 20px;\n        flex-direction: column;\n    }\n\n    .btn {\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .modal-header {\n        padding: 12px 16px;\n    }\n\n    .modal-body {\n        padding: 16px;\n    }\n\n    .modal-footer {\n        padding: 12px 16px;\n    }\n\n    .form-section {\n        margin-bottom: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
